import React from "react";

const StatusPill = ({
  variant,
  status,
  widthClass,
  outlined = true,
  size = "default",
  capitalize = false,
}) => {
  const pillVariantClass = {
    success: "bg-[#ECFDF3] text-[#067647] border-[#ABEFC6]",
    error: "bg-[#FEF3F2] text-[#B42318] border-[#FECDCA]",
    info: "bg-[#008FFF]/[8%] text-[#008FFF] border-[#93C5FD]",
    warning: "bg-[#FF2A54]/[8%] text-[#FF2A54] border-[#FACC15]",
    default: "bg-[#1F2937]/[8%] text-[#1F2937] border-[#D1D5DB]",
  };

  const sizeClass = {
    default: "text-14 px-8 py-2",
    medium: "text-13 px-8 py-2",
    small: "text-10 px-8 py-2",
  };

  return (
    <div
      className={`text-inter font-medium flex items-center justify-center rounded-full ${outlined ? "border" : ""}  ${pillVariantClass[variant]} ${widthClass} ${sizeClass[size]} ${capitalize ? "capitalize" : ""}`}
    >
      {status}
    </div>
  );
};

export default StatusPill;
